import { render, staticRenderFns } from "./WorkshiftLegend.vue?vue&type=template&id=db4965aa&scoped=true&"
import script from "./WorkshiftLegend.vue?vue&type=script&lang=js&"
export * from "./WorkshiftLegend.vue?vue&type=script&lang=js&"
import style0 from "./WorkshiftLegend.vue?vue&type=style&index=0&id=db4965aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4965aa",
  null
  
)

export default component.exports